import * as Dialog from '@radix-ui/react-dialog';
import Icon from '@/components/Icon';
import { Button } from '@/components/ui/button';
import { useConfirm } from '@/lib/confirm';

/**
 * The public surface's answer to `confirmAction`: the one modal pattern, the bottom sheet, with
 * the action as the one solid button and Cancel beside it. Mounted once by `Root`; the console
 * renders its own twin, because a sheet in warm charcoal over the instrument panel is a screen
 * from the wrong product.
 */
export default function ConfirmHost() {
  const request = useConfirm((state) => state.request);
  const answer = useConfirm((state) => state.answer);

  return (
    <Dialog.Root open={request !== null} onOpenChange={(open) => !open && answer(false)}>
      <Dialog.Portal>
        <Dialog.Overlay className="ee-scrim" />
        {request ? (
          <Dialog.Content className="ee-sheet">
            <div className="ee-sheet__head">
              <Dialog.Title className="ee-sheet__title">{request.title}</Dialog.Title>
              <Dialog.Close
                className="ee-header__icon"
                aria-label="Close"
                data-ee-feature={`${request.feature}.cancel`}
              >
                <Icon name="close" />
              </Dialog.Close>
            </div>

            <div className="ee-sheet__body">
              <Dialog.Description asChild>
                <p>{request.body}</p>
              </Dialog.Description>
            </div>

            <div className="ee-sheet__foot">
              <Button
                size="lg"
                variant="solid"
                onClick={() => answer(true)}
                data-ee-feature={`${request.feature}.confirm`}
              >
                {request.confirm}
              </Button>
              <Button
                variant="ghost"
                onClick={() => answer(false)}
                data-ee-feature={`${request.feature}.cancel`}
              >
                {request.cancel ?? 'Cancel'}
              </Button>
            </div>
          </Dialog.Content>
        ) : null}
      </Dialog.Portal>
    </Dialog.Root>
  );
}
